module.exports = __webpack_public_path__ + "img/only-catalogo.d1bef738.png";